<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>
          Dane osobowe przedstawiciela handlowego
          <hr />
        </h5>
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Imię:"
            label-for="input-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Wpisz imię przedstawiciela"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-lastname"
            label="Nazwisko:"
            label-for="input-lastname"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-lastname"
              v-model="form.lastname"
              type="text"
              required
              placeholder="Wpisz nazwisko przedstawiciela"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-email"
            label="Adres email:"
            label-for="input-email"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-email"
              v-model="form.email"
              type="email"
              disabled
              required
              placeholder="Wpisz adres email przedstawiciela"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-phone"
            label="Numer telefonu:"
            label-for="input-phone"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-phone"
              v-model="form.phone"
              type="tel"
              required
              placeholder="Wpisz numer telefonu przedstawiciela"
              v-mask="'48 ### ### ###'"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-2">
            Obszar działalności
            <hr />
          </h5>
          <b-form-group
            id="input-group-api_key"
            label="Lokalizacje, do których dostęp będzie miał przedstawiciel handlowy:"
            label-for="input-scopes"
            :description="scopes"
            class="col-12"
          >
            <tags-input
              input-id="input-scopes"
              v-model="form.api_keys"
              :existing-tags="allowedApiKeys"
              :typeahead="true"
              :typeahead-hide-discard="true"
              placeholder="Wpisz nazwę lokalizacji"
              :only-existing-tags="onlyExistingTags"
              :limit="limit"
            >
            </tags-input>
          </b-form-group>
          <div class="col-12 row">
            <div class="col-12">
              <b-button type="submit" variant="primary">Zapisz</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Create',
  async created() {
    const vm = this
    await vm.fetchScopes()
    await vm.fetchSalesRepresentativeData()
  },
  mounted() {},
  data() {
    return {
      form: {
        id: '',
        name: '',
        lastname: '',
        phone: '',
        email: '',
        api_keys: []
      },
      allowedApiKeys: [],
      onlyExistingTags: true,
      limit: 0,
      scopes: 'Dostępne do wyboru: '
    }
  },
  computed: {},
  methods: {
    async fetchSalesRepresentativeData() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'get-sales-representative')
      try {
        const response = await vm.$http.post('e-zacma/sales-representative/get', {
          id: vm.$route.params.id
        })
        vm.form.id = response.data.id
        vm.form.name = response.data.name
        vm.form.lastname = response.data.lastname
        vm.form.email = response.data.email
        vm.form.api_keys = JSON.parse(response.data.api_keys).map(key => ({
          key,
          value: vm.allowedApiKeys.find(allowedKey => allowedKey.key === key).value
        }))
        vm.form.phone = response.data.phone
      } catch (e) {
        vm.$handleLaravelFormErrorResponse(e)
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'get-sales-representative')
      }
    },
    onSubmit() {
      const vm = this

      if (
        typeof vm.form.api_keys === 'undefined' ||
        vm.form.api_keys === '' ||
        vm.form.api_keys.length === 0
      ) {
        vm.$error('Zakres działalności jest wymagany.')
        return
      }

      vm.$store.commit('addPageLoaderEvent', 'update-sales-representative')
      const fromData = { ...vm.form, api_keys: vm.form.api_keys.map(item => item.key) }
      vm.$http
        .post('e-zacma/sales-representative/modify', fromData)
        .then(() => {
          vm.$router.push({ name: 'e-zacma-sales-representatives' }) &&
            vm.$success('Przedstawiciel handlowy został edytowany')
        })
        .catch(error => {
          const { data } = error.response
          if (
            data &&
            data.errors &&
            data.errors.email &&
            data.errors.email[0] === 'The email has already been taken.'
          ) {
            vm.$error('Nie można utworzyć konta na podany adres email')
          } else if (
            data &&
            data.status &&
            data.message &&
            data.status === 422 &&
            data.message === 'Api keys are not in same scope'
          ) {
            vm.$error(
              'Podane lokalizacje nie znajdują się w tej samej organizacji! Zmień lokalizacje i spróbuj ponownie!',
              'Nie można zapisać przedstawiciela handlowego'
            )
          } else vm.$error()
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'update-sales-representative')
        })
    },
    fetchScopes() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const scopes = response.data
        let i = 0
        // eslint-disable-next-line no-restricted-syntax
        for (const scope of scopes) {
          // eslint-disable-next-line no-plusplus
          ++i
          vm.allowedApiKeys.push({ key: scope.api_key, value: scope.name })
          vm.scopes += scopes.length > i ? `${scope.name}, ` : scope.name
        }
        vm.limit = i
      })
    }
  }
}
</script>

<style scoped></style>
